<template>
  <el-dialog 
      class='jdy-modal' 
      :visible.sync="data.dialogVisible" 
      :append-to-body='true' 
      :width="data.dialogWidth"
      :showClose="!data.hideClose"
      :closeOnClickModal='!data.noCloseClickModal'
      :closeOnPressEscape='!data.noClosePressEscape'
      :class="{
        'dialogBody-noBottomPadding':data.bodyNoPadding === false
      }"
      @open='openEv'
      @close='closeEv'
  >
      <div slot='title'>
        <slot name='dialog-title'>{{data.dialogTitle}}</slot>
      </div>
      <slot name='dialog-body'>是否退出登录</slot>
      <div v-if='data.haveFooter' slot="footer">
        <div :class="['dialog-footer',{'f-align-center': data.footerAlign=='center','f-align-left': data.footerAlign=='left','border-none':data.footLine === false}]">
          <slot name='cancel'><el-button size='small' v-if='!data.hideCancel' @click="data.dialogVisible = false">取 消</el-button></slot>
          <slot name='submit'><el-button size='small' v-if='!data.hideSubmit' :disabled="data.disabled" type="primary" @click="data.callback">确 定</el-button></slot>
        </div>
      </div>
    </el-dialog>
</template>
<script>
  export default {
    name: 'modal',
    props:['data'],
    methods:{
      openEv(){},
      closeEv(){}
    },
    mounted(){
       typeof this.data.openCallback == 'function' && (this.openEv =  this.data.openCallback);
       typeof this.data.closeCallback == 'function' && (this.closeEv =  this.data.closeCallback);
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/modal.vue